// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-tmdb-movie-popular-tmdb-id-js": () => import("./../../../src/pages/{TmdbMoviePopular.tmdbId}.js" /* webpackChunkName: "component---src-pages-tmdb-movie-popular-tmdb-id-js" */),
  "component---src-pages-tmdb-tv-popular-tmdb-id-js": () => import("./../../../src/pages/{TmdbTvPopular.tmdbId}.js" /* webpackChunkName: "component---src-pages-tmdb-tv-popular-tmdb-id-js" */)
}

